import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { formatUnits, getPurchaseRules } from './productPurchase';

const valueStyle = {
  fontWeight: 700,
};

export default function ProductPurchaseInfo({ product, compact = false }) {
  const { minimum, step, presentation } = getPurchaseRules(product);

  if (compact) {
    return (
      <Box
        aria-label="Condiciones de compra"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 0.5,
          mt: 1,
        }}
      >
        <Typography
          component="span"
          variant="caption"
          sx={{ px: 1, py: 0.25, border: 1, borderColor: 'divider', borderRadius: 4 }}
        >
          Mínimo: <Box component="strong">{formatUnits(minimum)}</Box>
        </Typography>
        {step > 1 && (
          <Typography
            component="span"
            variant="caption"
            sx={{ px: 1, py: 0.25, border: 1, borderColor: 'divider', borderRadius: 4 }}
          >
            De {step} en {step}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      component="dl"
      aria-label="Condiciones de compra"
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        gap: '4px 12px',
        m: 0,
        mt: 2,
        textAlign: 'left',
      }}
    >
      {presentation && (
        <>
          <Typography component="dt" variant="body2" color="text.secondary">Presentación</Typography>
          <Typography component="dd" variant="body2" sx={{ ...valueStyle, m: 0 }}>{presentation}</Typography>
        </>
      )}
      <Typography component="dt" variant="body2" color="text.secondary">Compra mínima</Typography>
      <Typography component="dd" variant="body2" sx={{ ...valueStyle, m: 0 }}>{formatUnits(minimum)}</Typography>
      <Typography component="dt" variant="body2" color="text.secondary">Incrementos</Typography>
      <Typography component="dd" variant="body2" sx={{ ...valueStyle, m: 0 }}>{formatUnits(step)}</Typography>
    </Box>
  );
}
